var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskDonePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 154,
    viewBox: "0 0 303 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_19829)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 76,
    width: 189,
    height: 58,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 117C81.8125 116.969 79.8125 116.438 78 115.406C76.1875 114.344 74.7188 112.875 73.5938 111C72.5312 109.094 72 107.094 72 105C72 102.906 72.5312 100.906 73.5938 99C74.7188 97.125 76.1875 95.6562 78 94.5938C79.8125 93.5625 81.8125 93.0312 84 93C86.1875 93.0312 88.1875 93.5625 90 94.5938C91.8125 95.6562 93.2812 97.125 94.4062 99C95.4688 100.906 96 102.906 96 105C96 107.094 95.4688 109.094 94.4062 111C93.2812 112.875 91.8125 114.344 90 115.406C88.1875 116.438 86.1875 116.969 84 117ZM89.2969 102.797C89.7344 102.266 89.7344 101.734 89.2969 101.203C88.7656 100.766 88.2344 100.766 87.7031 101.203L82.5 106.406L80.2969 104.203C79.7656 103.766 79.2344 103.766 78.7031 104.203C78.2656 104.734 78.2656 105.266 78.7031 105.797L81.7031 108.797C82.2344 109.234 82.7656 109.234 83.2969 108.797L89.2969 102.797Z",
    fill: "#75B798"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 19,
    transform: "translate(112 87)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 12.801,
    transform: "translate(112 110)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 76,
    width: 8,
    height: 58,
    fill: "#75B798"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 76.5,
    width: 188,
    height: 57,
    rx: 7.5,
    stroke: "#CECEDA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_27_19829)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_19829)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.0606,
    y: 32,
    width: 188.939,
    height: 57.936,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.061 72.968C107.873 72.9368 105.873 72.4055 104.061 71.3743C102.248 70.3118 100.779 68.843 99.6544 66.968C98.5919 65.0618 98.0606 63.0618 98.0606 60.968C98.0606 58.8743 98.5919 56.8743 99.6544 54.968C100.779 53.093 102.248 51.6243 104.061 50.5618C105.873 49.5305 107.873 48.9993 110.061 48.968C112.248 48.9993 114.248 49.5305 116.061 50.5618C117.873 51.6243 119.342 53.093 120.467 54.968C121.529 56.8743 122.061 58.8743 122.061 60.968C122.061 63.0618 121.529 65.0618 120.467 66.968C119.342 68.843 117.873 70.3118 116.061 71.3743C114.248 72.4055 112.248 72.9368 110.061 72.968ZM115.357 58.7649C115.795 58.2336 115.795 57.7024 115.357 57.1711C114.826 56.7336 114.295 56.7336 113.764 57.1711L108.561 62.3743L106.357 60.1711C105.826 59.7336 105.295 59.7336 104.764 60.1711C104.326 60.7024 104.326 61.2336 104.764 61.7649L107.764 64.7649C108.295 65.2024 108.826 65.2024 109.357 64.7649L115.357 58.7649Z",
    fill: "#75B798"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.9394,
    height: 19.201,
    transform: "translate(138.061 42.967)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 12.801,
    transform: "translate(138.061 66.168)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0606,
    y: 32,
    width: 8,
    height: 58,
    fill: "#75B798"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.5606,
    y: 32.5,
    width: 187.939,
    height: 56.936,
    rx: 7.5,
    stroke: "#CECEDA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_19829",
    x: 36,
    y: 74,
    width: 197,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0901961 0 0 0 0 0.168627 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_19829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_19829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_27_19829",
    x: 18.0606,
    y: 0,
    width: 284.939,
    height: 153.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0901961 0 0 0 0 0.168627 0 0 0 0.175 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_19829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_19829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_19829"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.0606,
    y: 32,
    width: 188.939,
    height: 57.936,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDonePlaceholder);
export default __webpack_public_path__ + "static/media/task-done-placeholder.9d413cb8a27cb4ec3d89080f9f13d902.svg";
export { ForwardRef as ReactComponent };